<template> 
	<div>
		<!-- Main content Start -->
		<div v-if="loggedIn" class="top-info d-flex flex-row">
			<div v-if="ticketList.length>0" class="w-100 p-2 d-flex flex-row align-items-center clickable" @click="toggleShowTicketInfo">
				<div>
					<img v-show="showTicketInfo" src="assets/images/close.svg" alt="close" width="24px" height="24px">
					<img v-show="!showTicketInfo" src="assets/images/open.svg" alt="open" width="24px" height="24px">
				</div>
				<div class="pl-2">{{ ticketTopInfo }}</div>
			</div>
			<div v-else class="w-100 p-2">
			</div>
			<div v-if="notificationList.length>0" class="p-2 clickable" @click="toggleShowNotification">
				<img v-show="showNotification" src="assets/images/message_on.svg" alt="hide message" width="24px" height="24px">
				<img v-show="!showNotification" src="assets/images/message_attention.svg" alt="show message" width="24px" height="24px">
			</div>
			<div v-else class="p-2">
				<img src="assets/images/message.svg" alt="no message" width="24px" height="24px">
			</div>
			<div class="p-2 clickable" @click="toggleShowQuery">
				<img v-show="showQuery" src="assets/images/search_on.svg" alt="hide search" width="24px" height="24px">
				<img v-show="!showQuery" src="assets/images/search.svg" alt="search" width="24px" height="24px">
			</div>
		</div>
		<div class="relative container-fluid" v-bind:class="{'pt-3':isMobile||loggedIn, 'mt-3':!isMobile&&!loggedIn}">
			<div v-show="showTicketInfo" class="ticket-info w-100 pt-1">
				<div v-for="item in ticketList">
					<div class="pb-1 pl-2">{{ $t('Home.ticketDetail1') }} {{ item.expiration_date | formatTicketDate }} {{ $t('Home.ticketDetail2') }} {{ item.available }} {{ $t('Home.ticketDetail3') }}</div>
				</div>
			</div>
			<div v-show="showNotification" class="notification-info w-100">
				<div v-for="item in notificationList">
					<div class="notification-raw clickable p-2" @click="redirectToLessonDetail(item.lesson_id)">
						<div class="d-flex flex-row align-items-center">
							<div class="text-ellipsis w-100">{{ item.nickname }}</div>
							<div class="nowrap">{{ item.created_date | formatTicketDate }}</div>
							<div class="pl-2"><img src="assets/images/forward.svg" alt="open" width="20px" height="20px"></div>
						</div>
						<div class="text-ellipsis">{{ item.message_text }}</div>
					</div>
				</div>
			</div>
			<div v-show="showQuery" class="query-info w-100 p-2">
				<div class="d-flex flex-row  align-items-center">
					<input type="checkbox"
						id="available_flg"
						v-model="query.availableFlg"
						class=""
						@change="queryLesson"
					/>
					<label for="available_flg" class="ml-1 mb-0">
						{{ $t('Home.queryAvailable') }}
					</label>
					<label for="trainer" class="ml-2 mb-0">
						{{ $t('Home.queryTrainer') }}
					</label>
					<select
						id="trainer"
						ref="trainer"
						v-model="query.trainer"
						class="ml-1"
						@change="queryLesson"
					>
						<option value="">{{ $t('Home.queryAll') }}</option>
						<option v-for="trainer in trainerList" :value="trainer">
							{{ trainer }}
						</option>
					</select>
				</div>
			</div>
			<div class="row flex-row flex-nowrap overflow-auto pr-2" v-for="n in rows">
				<div v-if="n==1&&loggedUserPlan==''&&!isTrainer&&!isMobile" class="col-11 col-md-5 col-xl-3 mb-3 pl-2 pr-0">
					<banner-plans></banner-plans>
				</div>
				<div class="col-11 col-md-5 col-xl-3 mb-3 pl-2 pr-0" :key="index" v-for="(item, index) in sliceList(n)">
					<lesson-card :item="item" @click="redirectToLessonDetail"></lesson-card>
				</div>
			</div>
		</div>
		<!-- Main content End -->
	</div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import moment from "moment"
import LessonCard from '@/components/LessonCard.vue'
import BannerPlans from '@/components/BannerPlans.vue'

export default {
	name: 'HomeContent',
	props: ['isMobile'],
	components: {
		LessonCard,
		BannerPlans,
	},
	data() {
	    return {
			allLessonList: [],
			lessonList: [],
			perRow: 4,
			showTicketInfo: false,
			showNotification: false,
			showQuery: false,
			query: {
				availableFlg: false,
				trainer: "",
			},
			trainerList: [],
			ticketList: [],
			notificationList: [],
	    }
	},
	computed: {
		ticketTopInfo: function() {
			if (this.ticketList.length > 0) {
				for (let index = 0; index < this.ticketList.length; index++) {
					if (this.ticketList[index].available > 0) {
						let expirationDate = "";
						if (window.navigator.language == 'ja' || window.navigator.language == 'ja-JP') {
							expirationDate = moment(String(this.ticketList[index].expiration_date)).format('Y/MM/DD HH:mm')
						} else {
							expirationDate = moment(String(this.ticketList[index].expiration_date)).format('lll')
						}
						return this.$t('Home.ticketHead', { tickets: this.ticketList[index].available, expiration_date: expirationDate });
					}
				}
				return this.$t('Home.ticketHeadZero');
			}
			return "";
		},
		loggedIn: function() {
			return this.$store.state.loggedIn;
		},
		isTrainer: function() {
			return this.$store.state.isTrainer;
		},
		loggedUserPlan: function() {
			return this.$store.state.loggedUserPlan;
		},
		loggedUserID: function() {
			return this.$store.state.loggedUserID;
		},
		setFromMobile: function() {
			return this.$store.state.setFromMobile;
		},
		rows: function() {
			if (!this.isMobile && !this.isTrainer && this.loggedUserPlan == '') {
				return Math.ceil((this.lessonList.length + 1) / this.perRow)
			} else {
				return Math.ceil(this.lessonList.length / this.perRow)
			}
		}
	},
	mounted() {
		if (this.loggedIn) {
			this.query.availableFlg = this.$store.state.queryAvailableFlg;
			this.query.trainer = this.$store.state.queryTrainer;
		}
		this.init();
	},
	beforeDestroy() {
		if (this.loggedIn) {
			this.$store.commit('setQuery', this.query);
		}
	},
	watch: {
		setFromMobile: function (val) {
			if (val && this.isMobile) {
				if (this.loggedIn && !this.isTrainer) {
					this.getUserTicketRemaining();
				}
				if (this.loggedIn) {
					this.getNotification();
				}
			}
		},
	},
	methods: {
		init() {
			this.getLesson();
			if (this.loggedIn && !this.isTrainer) {
				this.getUserTicketRemaining();
			}
			if (this.loggedIn) {
				this.getNotification();
			}
		},
		getLesson() {
			let loader = this.$loading.show()
			axios.get(EMSStyleAPIBaseURL + 'lesson')
			.then(response => {
				let now = moment();
				this.allLessonList = response.data
				.filter(item => {
					if (item.same_day_reservation_flg) {
						// 当日予約可の場合はレッスン開始日時から30分前が予約締め切り日時
						return moment(item.from_date + "Z").subtract(30, 'minutes').isAfter(now);
					} else {
						// 当日予約不可の場合はレッスン開始日時から24時間前が予約締め切り日時
						return moment(item.from_date + "Z").subtract(1, 'days').isAfter(now);
					}
				})
				.sort((a, b) => {
					//from_dateの昇順
					if(a.from_date > b.from_date) return 1;
					if(a.from_date < b.from_date) return -1;
					return 0;
				});
				const trainerSet = new Set();
				this.allLessonList.forEach(item => {
					item.from_date = item.from_date + "Z";
					item.to_date = item.to_date + "Z";
					trainerSet.add(item.trainer_nickname);
				});
				this.trainerList = Array.from(trainerSet).sort();
				this.queryLesson();
				loader.hide()
			})
			.catch((error) => {
				loader.hide()
				console.error(error)
				this.$swal({
					text: this.$t('general.errorMessage'),
					icon: 'error',
				});
			});
		},
		getUserTicketRemaining() {
			let loader = this.$loading.show()
			axios.get(EMSStyleAPIBaseURL + 'ticket/valid-list')
			.then(response => {
				this.ticketList = response.data
				.sort((a, b) => {
					//expiration_dateの昇順
					if(a.expiration_date > b.expiration_date) return 1;
					if(a.expiration_date < b.expiration_date) return -1;
					return 0;
				});
				this.ticketList.forEach(item => {
					item.expiration_date = item.expiration_date + "Z";
				});
				loader.hide()
			})
			.catch((error) => {
				loader.hide()
				console.error(error)
			});
		},
		getNotification() {
			let loader = this.$loading.show()
			axios.get(EMSStyleAPIBaseURL + 'notification')
			.then(response => {
				let now = moment();
				this.notificationList = response.data
				.sort((a, b) => {
					//created_dateの昇順
					if(a.created_date > b.created_date) return 1;
					if(a.created_date < b.created_date) return -1;
					return 0;
				});
				this.notificationList.forEach(item => {
					item.created_date = item.created_date + "Z";
				});
				loader.hide()
			})
			.catch((error) => {
				loader.hide()
				console.error(error)
				this.$swal({
					text: this.$t('general.errorMessage'),
					icon: 'error',
				});
			});
		},
		queryLesson() {
			if(this.query.availableFlg) {
				this.lessonList = this.allLessonList.filter(item => {
					return item.max_member - item.reservation_count > 0;
				});
			} else {
				this.lessonList = this.allLessonList;
			}
			if (this.query.trainer != "") {
				this.lessonList = this.lessonList.filter(item => {
					return item.trainer_nickname == this.query.trainer;
				});
			}
		},
		sliceList(n) {
			if (!this.isMobile && !this.isTrainer && this.loggedUserPlan == '') {
				if (n == 1) {
					return this.lessonList.slice(0, 3);
				} else {
					return this.lessonList.slice((n-1)*this.perRow - 1, n*this.perRow - 1);
				}
			} else {
				return this.lessonList.slice((n-1)*this.perRow, n*this.perRow);
			}
		},
		redirectToLessonDetail(lessonId) {
			if (this.isMobile) {
				this.$router.push(`/mlesson-detail/${lessonId}`);
			} else {
				this.$router.push(`/lesson-detail/${lessonId}`);
			}
		},
		toggleShowTicketInfo() {
			this.showNotification = false;
			this.showQuery = false;
			this.showTicketInfo = !this.showTicketInfo;
		},
		toggleShowNotification() {
			this.showTicketInfo = false;
			this.showQuery = false;
			this.showNotification = !this.showNotification;
		},
		toggleShowQuery() {
			this.showTicketInfo = false;
			this.showNotification = false;
			this.showQuery = !this.showQuery;
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top-info {
	background-color: white;
	border-bottom: 1px solid #bbb;
	border-left: 1px solid #bbb;
	font-size: 0.7rem;
}
.clickable {
	cursor:pointer;
}
.relative {
	position: relative;
}
.ticket-info {
	background-color: white;
	border-bottom: 1px solid #bbb;
	border-left: 1px solid #bbb;
	font-size: 0.7rem;
	z-index: 1;
	position: absolute;
	top: 0;
	left: 0;
}
.notification-info {
	background-color: white;
	font-size: 0.7rem;
	z-index: 1;
	position: absolute;
	top: 0;
	left: 0;
}
.notification-raw {
	border-bottom: 1px solid #bbb;
	border-left: 1px solid #bbb;
}
.query-info {
	background-color: white;
	border-bottom: 1px solid #bbb;
	border-left: 1px solid #bbb;
	font-size: 0.8rem;
	z-index: 1;
	position: absolute;
	top: 0;
	left: 0;
}
.nowrap {
	white-space: nowrap
}
.text-ellipsis {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>
